var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-top: 0px;\n    ul {\n        list-style: none;\n        padding-left: 0px;\n        li {\n            width: 30px;\n            display: inline-block;\n            text-align: left;\n        }\n        }\n        a {\n        color: ', ';\n        &:hover {\n            img {\n            opacity: 0.9;\n            }\n        }\n    }\n    img {\n        max-height: 16px;\n        transition: all 0.25s ease-in-out;\n    }\n'], ['\n    padding-top: 0px;\n    ul {\n        list-style: none;\n        padding-left: 0px;\n        li {\n            width: 30px;\n            display: inline-block;\n            text-align: left;\n        }\n        }\n        a {\n        color: ', ';\n        &:hover {\n            img {\n            opacity: 0.9;\n            }\n        }\n    }\n    img {\n        max-height: 16px;\n        transition: all 0.25s ease-in-out;\n    }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var StyledSocialLinks = styled.div(_templateObject, function (props) {
  return props.theme.colours.primary.lighter;
});

var SocialLinks = function (_React$Component) {
  _inherits(SocialLinks, _React$Component);

  function SocialLinks() {
    _classCallCheck(this, SocialLinks);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SocialLinks.prototype.render = function render() {
    var links = this.props.links;
    return React.createElement(StyledSocialLinks, this.props, React.createElement('ul', null, links.map(function (link, index) {
      return React.createElement('li', {
        key: index
      }, React.createElement('a', {
        target: '_blank',
        href: link.href
      }, React.createElement('img', {
        alt: 'social',
        src: link.img
      })));
    })));
  };

  return SocialLinks;
}(React.Component);

export { SocialLinks as default };